import { useState } from "react";
import { Link } from "@tanstack/react-router";
import { Presentation } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CatalogBrowser } from "@/components/wholesale/catalog-browser";
import { CatalogItemSheet, type CatalogSelection } from "@/components/wholesale/catalog-item-sheet";

export function WholesaleCatalogPage() {
  const [selected, setSelected] = useState<CatalogSelection | null>(null);

  return (
    <div className="p-4 flex flex-col gap-3">
      {/* Shopove uključene u veleprodaju nabraja filter pretrage i kolona „Shop“ u
          rezultatima, pa ih zaglavlje stranice više ne ponavlja. */}
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <h2 className="text-sm font-medium">Katalog veleprodaje</h2>
        <div className="flex items-center gap-3">
          <p className="text-[11px] text-muted-foreground hidden md:block">
            Klik na red otvara detalje, ikona kopira SKU.
          </p>
          <Button variant="outline" size="sm" asChild>
            <Link to="/wholesale/prezentacija">
              <Presentation />
              Prezentacija
            </Link>
          </Button>
        </div>
      </div>

      <CatalogBrowser onOpen={setSelected} />

      <CatalogItemSheet selection={selected} onOpenChange={(open) => !open && setSelected(null)} />
    </div>
  );
}
